<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['sendMessage']);
</script>

<template>
  <div
    class="flex flex-row gap-2 items-center select-none w-full rounded-lg bg-n-slate-2 border border-n-weak m-0 cursor-pointer justify-between py-2 px-4"
    @click="emit('sendMessage', item)"
  >
    <div class="space-y-1 text-n-slate-12">
      <h5 class="text-n-slate-12 text-sm mb-0 py-0 pr-2 pl-0 font-medium">
        {{ item.title }} ?
      </h5>
      <div class="break-words">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>
